<template>
  <div v-if="show_modal">
    <div
      class="modal fade"
      :class="show_modal ? 'show' : ''"
      style="display: block"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-lg modal-dialog-centered"
        role="document"
        style="max-width: 90%; transition: 0.3s"
      >
        <div class="modal-content">
          <div class="modal-body pt-3 pb-0" style="min-height: 350px">
            <!-- header -->
            <div style="line-height: 17px" class="mb-4">
              <h3 class="m-0">Detail Retur Penjualan Group</h3>
              <div class="mb-1">
                No Group
                <span class="click-able">{{
                  detail_retur.id_retur_penjualan_group
                }}</span>
              </div>
              <div class="info-header mt-3">
                <div class="mb-1">
                  No Retur
                  <span class="click-able">
                    <span
                      class="m-0 p-0"
                      v-for="(row, index) in detail_retur.id_retur_penjualan"
                    >
                      {{ row }}
                      {{
                        index == detail_retur.id_retur_penjualan.length - 1
                          ? ""
                          : ","
                      }}
                    </span>
                  </span>
                </div>
                <div class="mb-1">
                  No Acc
                  <span class="click-able">{{ detail_retur.no_acc_toko }}</span>
                </div>
                <div class="mb-1">
                  No Cust
                  <span class="click-able">{{
                    detail_retur.no_cust_toko
                  }}</span>
                </div>
                <div class="mb-1">
                  Nama Toko
                  <span class="click-able">{{ detail_retur.nama_toko }}</span>
                </div>
                <div class="mb-1">
                  Alamat
                  <span class="click-able">{{ detail_retur.alamat_toko }}</span>
                </div>
                <div class="mb-1">
                  Gudang
                  <span class="click-able">{{ detail_retur.nama_gudang }}</span>
                </div>
                <div class="mb-1">
                  Tipe Barang
                  <span class="click-able">{{ detail_retur.tipe_barang }}</span>
                </div>
                <div class="mb-1">
                  Status PPN
                  <span class="click-able text-capitalize">{{
                    detail_retur.status_ppn
                  }}</span>
                </div>
                <div class="mb-1">
                  TIM
                  <span class="click-able">{{ detail_retur.nama_tim }}</span>
                </div>
                <div class="mb-1">
                  Salesman
                  <span class="click-able">{{
                    detail_retur.nama_salesman
                  }}</span>
                </div>
                <div class="mb-1">
                  No Invoice Penjualan
                  <span class="click-able">
                    <span
                      class="m-0 p-0"
                      v-for="(row, index) in detail_retur.no_invoice_penjualan"
                    >
                      {{ row }}
                      {{
                        index == detail_retur.no_invoice_penjualan.length - 1
                          ? ""
                          : ", "
                      }}
                    </span>
                  </span>
                </div>
              </div>

              <div class="modal-control">
                <b-dropdown
                  variant="link"
                  size="lg"
                  dropleft
                  no-caret
                  class="btn-modal-control"
                >
                  <template slot="button-content">
                    <i style="font-size: 16px" class="fe fe-printer"></i>
                  </template>
                  <b-dropdown-item @click="print(false)"
                    >Preview Invoice</b-dropdown-item
                  >
                  <b-dropdown-item @click="print(true)"
                    >Print Invoice</b-dropdown-item
                  >
                </b-dropdown>
                <button
                  class="btn-modal-control"
                  v-html="ic('refresh')"
                  @click="refreshData"
                  :disabled="loading"
                />
                <button
                  class="btn-modal-control"
                  v-html="ic('close')"
                  :disabled="loading"
                  @click="show_modal = false"
                />
              </div>
            </div>

            <div class="card">
              <div
                class="card-body p-0 table-responsive"
                style="min-height: 350px"
              >
                <div class="table-dpb">
                  <table
                    class="table table-v center table-hover card-table table-striped table-no-break"
                  >
                    <thead>
                      <tr class="text-muted">
                        <th>No Retur</th>
                        <th>Tim & Gudang</th>
                        <th>Kat. Retur</th>
                        <th>Status</th>
                        <th>Grand Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="loading">
                        <td colspan="10" style="padding: 0px !important">
                          <Skeleton
                            type="table"
                            :length="5"
                            class="mt-3 bg-white m-2"
                          />
                        </td>
                      </tr>
                      <tr v-if="detail_retur.length === 0">
                        <td colspan="10">Tidak ada data...</td>
                      </tr>
                      <tr
                        v-for="(row, index) in detail_retur.details"
                        :key="index"
                        v-if="!loading"
                      >
                        <td>
                          <span
                            class="link-primary cursor-pointer"
                            @click="_detail(row.id_retur)"
                          >
                            {{ row.id_retur }}
                          </span>
                        </td>

                        <td>
                          {{ row.nama_tim }} ({{ row.tipe_tim }}) <br />
                          {{ row.nama_gudang }}
                        </td>
                        <td>{{ row.tipe_barang }}</td>
                        <td>
                          <span
                            class="btn btn-sm"
                            :class="
                              row.status == 'waiting'
                                ? 'btn-warning'
                                : row.status == 'approved'
                                ? 'btn-primary'
                                : ''
                            "
                          >
                            {{ row.status }}
                          </span>
                        </td>
                        <td>{{ row.grand_total | currency }}</td>
                        <div
                          class="btn-group"
                          style="padding-right: 75px; padding-top: 5px"
                        >
                          <button
                            class="btn btn-white btn-pill"
                            @click="_delete(row.id_retur)"
                            v-html="ic('trash')"
                          ></button>
                        </div>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="px-4 pt-3">
            <span class="badge-md strong mr-2">
              Subtotal <span>{{ detail_retur.subtotal | currency }}</span>
            </span>
            <span class="badge-md strong mr-2">
              Diskon <span>{{ detail_retur.discount | currency }}</span>
            </span>
            <span class="badge-md strong mr-2">
              DPP <span>{{ detail_retur.dpp | currency }}</span>
            </span>
            <span class="badge-md strong mr-2">
              Total Dus <span>{{ detail_retur.total_dus }}</span>
            </span>
            <span class="badge-md strong mr-2">
              Total Pcs <span>{{ detail_retur.total_pcs }}</span>
            </span>
            <span class="badge-md strong mr-2">
              PPn <span>{{ detail_retur.ppn | currency }}</span>
            </span>
            <span class="badge-md strong mr-2">
              Grand Total <span>{{ detail_retur.grand_total | currency }}</span>
            </span>
          </div>

          <div class="px-4 py-4 text-right">
            <!-- <button
                            type="button"
                            class="btn btn-primary ml-3"
                            @click="print()"  
                            v-html="`Print`"
                        />
                         -->
            <button
              @click="show_modal = false"
              type="button"
              class="btn btn-white ml-2"
              v-html="'Tutup'"
            />
          </div>
        </div>
      </div>
    </div>
    <DetailRetur @refresh="_get({ silent: true })" />
  </div>
</template>

<script>
import helper from "@/assets/js/helper";
import { mapState, mapActions, mapMutations } from "vuex";
import DetailRetur from "@/pages/dashboard/sales/retur-penjualan/modals/detail-retur.vue";

export default {
  name: "DetailReturGroup",
  components: {
    DetailRetur,
  },
  props: {
    view: false,
  },
  mixins: [helper],
  data() {
    return {
      loading: false,
      closed: {
        config: { view: false, title: null },
        data: null,
        isSubmit: false,
        action: () => {},
      },
    };
  },
  computed: {
    ...mapState("retur_penjualan_group", {
      detail_retur: (state) => state.datas.detail_group,
    }),
    show_modal: {
      get() {
        return this.$store.state.retur_penjualan_group.show_modal_detail;
      },
      set(val) {
        return this.$store.commit(
          "retur_penjualan_group/SET_DETAIL_MODAL",
          val
        );
      },
    },
  },
  methods: {
    ...mapActions("retur_penjualan_group", [
      "showReturPenjualanGroup",
      "countPrint",
      "unsetFromGroup",
    ]),
    ...mapActions("retur", ["getRetur", "getDetailRetur"]),
    ...mapMutations("retur", [
      "SET_DETAIL_MODAL",
      "ASSIGN_DATA_RETUR",
      "ASSIGN_DATA_DETAIL_RETUR",
    ]),
    async print(isPrint) {
      const header = this.detail_retur;
      const details = header.detail_items;
      delete header.detail_items;
      const data = {
        header: header,
        details: details,
        isPrint: isPrint,
      };
      localStorage.retur = JSON.stringify(data);

      if (isPrint) {
        try {
          const res = await this.countPrint(encodeURIComponent(header.id_retur_penjualan_group))
          this.$emit("fetchIndex");
        } catch (err) {
          console.log(err);
        }
      }

      window.open(
        window.location.origin + "/dashboard/sales/retur-penjualan-group/print",
        "_blank"
      );
    },
    async refreshData() {
      const id = this.detail_retur.id_retur_penjualan_group;
      try {
        this.loading = true;
        const res = await this.showReturPenjualanGroup(id);
        this.loading = false;
      } catch (err) {
        console.log(err);
      }
    },
    _detail(id) {
      this.SET_DETAIL_MODAL(true);
      this.ASSIGN_DATA_RETUR({});
      this.ASSIGN_DATA_DETAIL_RETUR({});
      this.getRetur(id);
      this.getDetailRetur(id);
    },
    async _delete(id) {
      try {
        this.loading = true;
        const res = await this.unsetFromGroup(encodeURIComponent(id));
        if (this.detail_retur.details.length <= 1) {
          this.show_modal = false;
        } else {
          this.refreshData();
        }
        this.$emit("fetchIndex");
        this.loading = false;
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
<style lang="scss" src="../retur-penjualan.scss" scoped />
